export default {
    "fr": {
        "or": "ou",
        "Edit": "Modifier",
        "Close": "Fermer",
        "Update": "Mettre à jour",
        "Save": "Enregistrer",
        "days": {
            "mo": "Lundi",
            "tu": "Mardi",
            "we": "Mercredi",
            "th": "Jeudi",
            "fr": "Vendredi",
            "sa": "Samedi",
            "su": "Dimanche"
        },
        "count goods": "1 marchandise|{count} marchandises",
        "count days": "1 jour|{count} jours",
        "An error has occured": "Une erreur est survenue.",
        "All rights reserved": "Tous droits réservés",
        "CGV": "Conditions générales de vente"
    },
    "en": {
        "or": "or",
        "Edit": "Edit",
        "Close": "Close",
        "Update": "Update",
        "Save": "Save",
        "days": {
            "mo": "Monday",
            "tu": "Tuesday",
            "we": "Wednesday",
            "th": "Thursday",
            "fr": "Friday",
            "sa": "Saturday",
            "su": "Sunday"
        },
        "An error has occured": "An error has occured",
        "All rights reserved": "All rights reserved",
        "CGV": "General terms and conditions"
    }
}
